// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__SSMm2","title":"style_title__suoH8","rows":"style_rows__14IJy","row":"style_row__3ayYk","icon-wrap":"style_icon-wrap__2CTJ5"};